import React, { Component } from 'react';
import Map from 'lodash/map';
//import Filter from 'lodash/filter';
import PropTypes from 'prop-types';
import * as axios from 'axios';
import * as moment from 'moment';
import $ from 'jquery';
import 'slick-carousel/slick/slick.js';
import './PhotoGallery.scss';
import Each from 'lodash/each';
import loadImage from 'image-promise';

//declare var jquery: any;
//declare var $: JQueryStatic;

declare var document:any;

class PhotoGallery extends Component {
  

  isVideo() {
    if(this.props.videoUrl) {
      return ' video';
    } else {
      return '';
    }
    //search-api/news/_search?query_string=*
  }

  constructor(props) {
    super(props);

    this.id = moment().toDate().getTime();
    
    this.$carousel = null;
    this.state = {
      data: {
        hits: {
          hits: []
        }
      },
      id:  this.id,
      ready: false,
      open: false,
      currentSlide: 1
    };
  }

  componentDidMount() {
    if(this.props.override) {
     
     if(window[this.props.override]) {

       this.setState({ data: { hits: { hits: window[this.props.override] }}, ready: true, id:  this.id});
     }
      
    } else {

   
      let keywords = this.props.keywords;
      keywords = Map(keywords, (item, key) => {
        return item.trim();
      });

      
      let mustMatchKeywords = [];
      keywords.forEach((item) => {
        let data = {};
        data.match = { "tags_terms" : item };
        mustMatchKeywords.push(data);
      });
      


      let paramsBody = {
        'from': (this.props.from)? parseInt(this.props.from, 10): 0,
        'size': (this.props.size)? parseInt(this.props.size, 10): 12,
        'query': {}
      };
      /*
      {
    "terms" : {
        "tags" : [ "blue", "pill" ],
        "minimum_should_match" : 1
    }
  }*/
      if(this.props.keywordsOperator === 'OR') {
        paramsBody.query.bool = {
          minimum_should_match: 1,
          should: mustMatchKeywords,
          must: { "query_string": { "query":  (this.props.query)? this.props.query: '*' }}
        };

       /* paramsBody.query.constant_score = {
              "filter" : {
                  "terms" : { "tags_terms" : ["campus-life"]}
              }
          }*/
      } else {
        paramsBody.query.bool = {
          must: mustMatchKeywords
        };
        mustMatchKeywords.push({ "query_string": { "query":  (this.props.query)? this.props.query: '*' }});
      }



      let sortBy = {};
      let sortByField = (this.props.sortField)? this.props.sortField: 'title';
      sortBy['cover_image'] = { 
        'order': (this.props.sortOrder)? this.props.sortOrder: 'desc'
      };
      sortBy[sortByField] = { 
        'order': (this.props.sortOrder)? this.props.sortOrder: 'desc'
      };

      paramsBody.sort = [sortBy];


      axios({
        method: 'GET',
        url: '/search-api/'+this.props.site+'/'+this.props.contentType+'/_search?',
        headers: {
          'Content-Type': 'application/json'
        },
        params: { body: paramsBody }
      }).then((response) => {
        this.setState({ data: response.data, ready: true, id:  this.id});

      })
      .catch((error) => {
        //console.log(error);
      });
 /*     console.log('JSON.stringify(paramsBody)', JSON.stringify(paramsBody));
      axios({
        method: 'POST',
        url: '/search-api/'+this.props.site+'/'+this.props.contentType+'/_search?',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(paramsBody)
       // params: { body: paramsBody }
      }).then((response) => {
        console.log('response', response);
        this.setState({ data: response.data, ready: true, id:  this.id});

      })
      .catch((error) => {
        //console.log(error);
      });*/

    }
    
  }
  dateFormat(dateTime) {
   //return dateTime;
    return moment(dateTime,'X').format("dddd, MMMM Do YYYY");
  }

  inputKeyBoardEvents(event) {
    if (event.keyCode === 27 || event.keyCode === 8) {
      this.closeGalleryModal(event);
    }

    if(event.keyCode === 37) {
        this.$carousel.slick('slickPrev');
    }
    if(event.keyCode === 39) {
        this.$carousel.slick('slickNext');
    }
  
  }

  get_orientation(src){

    let img = new Image();
    img.src = src;
    var width = img.width;
    var height = img.height;
    //height = height + (height / 2) // Increase height by 50%
    if(width > height) { 
      return "landscape"; 
    } else {
      return "portrait";
    }

  }
  openGalleryModal(e) {

    $('body, html').addClass('modal-open');
    //console.log( $('#modal_'+this.state.id));
    var preloadImages = [];
    Each(this.state.data.hits.hits, (item) => {
      preloadImages.push(item._source.url_large);
    });
    loadImage(preloadImages).then(() => {
      let value =  Map(this.state.data.hits.hits, (item) => {
        item._source.image_orientation = this.get_orientation(item._source.url_large);
        return item;
        
      });


      //this.setState({ data: value });

      this.setState({ data: { hits: { hits: value } } });
    });
    this.setState({ open: true }, () => {
      //on rendered

    
      this.$carousel = $(".carousel").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        nextArrow: '.next',
        prevArrow: '.previous'
      });
      this.$carousel.on('afterChange', (event, slick, currentSlide, nextSlide) =>{
        this.setState({ currentSlide: currentSlide +1 });
      });
      document.addEventListener('keyup', this.inputKeyBoardEvents.bind(this));
      //slickNext
      //
    //document.addEventListener('keyup', this.inputKeyBoardEvents.bind(this));
      
    });
    e.stopPropagation();
    e.preventDefault();
    return false;

  }

  closeGalleryModal(e) {
    this.$carousel.slick("unslick");
    $('body, html').removeClass('modal-open');
    document.removeEventListener('keyup', this.inputKeyBoardEvents.bind(this));
    this.setState({ open: false, currentSlide: 1 });
  }
  showCaption(flag) {
    if(typeof flag._source.caption !== 'undefined') { 
      return (
        <div className="gallery-item-description" dangerouslySetInnerHTML={{__html: flag._source.caption.value}} ></div>
      )
    } else {
      return null;
    }
  }

  showModal(){
    if(this.state.open) {
      return (
        <div className="photo-gallery-modal">
                <div className="photo-gallery-modal-bg close"></div>
                <div className="photo-gallery-modal-content">
                  <span className="close" onClick={(e) => this.closeGalleryModal(e)}>Close</span>
                  
                  <div className="controls-slides-info-wrapper">
                    <div className="controls">
                      <button className="previous">Previous</button>
                      <button className="next">Next</button>
                    </div>
                    <div className="slides-info">
                      <span className="slides-info-number"> {this.state.currentSlide} </span>
                      of <span className="slides-info-total"> {this.state.data.hits.hits.length} </span>
                    </div>
                  </div>
                  <div className="carousel">
                    {this.state.data.hits.hits.map((d,i) => {
                      let image;
                      if(d._source.markup) {
                        image = (<span dangerouslySetInnerHTML={{__html: d._source.markup}} />);
                      } else {
                        image = (<img src={d._source.url_large} 
                                  alt={d._source.title} 
                                  className={ 'gallery-image ' + d._source.image_orientation}/>)
                      }
                      return (
                          <div key={i} className={ 'gallery-item ' + d._source.image_orientation}>
                            <div className="gallery-item-wrapper">
                              <div className="gallery-item-image">
                                {image}
                              </div>

                              <div className="gallery-item-text">
                                <div className="gallery-item-title">{d._source.title}</div>
                                {this.showCaption(d)}
                                <div className="gallery-item-tagged">
                                  <strong>Tagged: </strong>
                                  {d._source.tags_terms.map((keyword,keywordIndex) => { 
                                      let divider = ' | ';
                                      if(keywordIndex === d._source.tags_terms.length - 1) {
                                        divider = '';
                                      }
                                      return (<span key={keywordIndex}>{keyword}{divider}</span>)
                                    }
                                  )}
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        );

                      }
                      
                    )}
                  </div>

                </div>
              </div>);
    } else {
      return null;
    }
    
  }

  render() {
    if(this.state.ready) {
      if(this.state.data.hits.hits.length) { 


        return (
          <div className="photo-gallery-brick">
            <div className="photo-gallery" onClick={(e) => this.openGalleryModal(e)}>
              <div className="image cover-image first-image">
                <img src={this.state.data.hits.hits[0]._source.url_large}  alt=""/>
              </div>
              <div className="cta-block trigger-gallery-modal" data-carousel-items="">
                {this.props.subheader? <h4 className="subheadline">{this.props.subheader}</h4>:""}
                <div className="headline">{this.props.header}</div>
                <div className="line"></div>
                <button className="cta-area" 
                  style={{background: 'none',
                        border: 'none',
                        color: 'inherit',
                        display: 'inline',
                        textAlign: 'left'}}>
                  <span className="cta-text">View Gallery</span>
                </button>
              </div>
              <div className="image cover-image second-image">
                <img src={this.state.data.hits.hits[1]._source.url_large} alt=""/>
              </div>
              <div className="image cover-image third-image">
                <img src={this.state.data.hits.hits[2]._source.url_large} alt=""/>
              </div>
            </div>
            {this.showModal()}
          </div>);
        } else {
          return (<div>No images match keywords {this.props.keywords}.</div>);
        }

    } else {
      return (<div>LOADING...</div>);
    }
  }
}


PhotoGallery.propTypes = {
  size: PropTypes.number,
  from: PropTypes.number,
  sortOrder: PropTypes.string,
  sortField: PropTypes.string,
  query: PropTypes.string,
 
  // A value of any data type
  site: PropTypes.string,
  contentType: PropTypes.string,
  subheader: PropTypes.string,
  header: PropTypes.string,
  keywords: PropTypes.array,
};

export default PhotoGallery;






// WEBPACK FOOTER //
// ./src/PhotoGallery/PhotoGallery.js